import Axios from '@/services/axios'
import msg from '@/common/msg'
import * as code from '@/common/code'

export default {
  getLongtermStock () {
    return new Promise((resolve, reject) => {
      Axios.get(
        'Warehouse/salemon-agent/long-term',
        {},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getProductAvailable () {
    return new Promise((resolve, reject) => {
      Axios.get(
        'Warehouse/salemon-agent/available',
        {},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  regisProducts (params = {}) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'Warehouse/salemon-agent/products',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            if (response.data.header.resultCode === code.reachProductLimit) {
              resolve(response.data.records)
            }
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getProductsToAmazonDelivery () {
    return new Promise((resolve, reject) => {
      Axios.get(
        'Warehouse/salemon-agent/products-to-amazon-delivery',
        {},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  updateSettingNotice (params = {}) {
    return new Promise((resolve, reject) => {
      Axios.put(
        'Warehouse/salemon-agent/setting-notice',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/salemonagentservice.js